import { Card, Grid } from '@mui/material'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'

const Menus: any[] = []

const CodCheckerPage = () => {
  return (
    <ContentWrapper>
      <Helmet title="ตรวจสอบ COD" />
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="COD Checker"
            routes={Menus}
            descriptions="COD Checker"
          />
        </Grid>
      </Grid>
      <Card>
        <iframe
          src="https://codchecker.systemtong.com/cod"
          frameBorder="0"
          width="100%"
          className="ifrm"
          height="700px"
        ></iframe>
      </Card>
    </ContentWrapper>
  )
}

export default CodCheckerPage
